/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Freeze_Weeks_LabelInputs */

const fr_membership_freeze_weeks_label = /** @type {(inputs: Membership_Freeze_Weeks_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durée`)
};

/**

* @param {Membership_Freeze_Weeks_LabelInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_freeze_weeks_label = /** @type {((inputs?: Membership_Freeze_Weeks_LabelInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Freeze_Weeks_LabelInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_freeze_weeks_label(inputs)
});